import React from "react";
import { Link } from "react-router-dom";
import { Mail, MessageCircle } from "lucide-react";
import { CONTACT_EMAIL, whatsappHref } from "@/config";
import { SECTORS } from "@/data/sectors";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-ax-border bg-ax-surface">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <div className="font-heading font-extrabold text-xl text-ax-text">
          Axio<span className="text-ax-orange">Form</span> 3D
        </div>
        <p className="text-sm text-ax-sub mt-3 leading-relaxed max-w-xs">
          Serviço de impressão e fabrico 3D de alta precisão em Portugal. Da ideia à peça real.
        </p>
      </div>
      <div>
        <h5 className="font-mono text-xs uppercase tracking-widest text-ax-muted mb-4">Contacto</h5>
        <a data-testid="footer-email" href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-2 text-ax-sub hover:text-ax-cyan transition-colors">
          <Mail className="w-4 h-4" /> {CONTACT_EMAIL}
        </a>
        <a data-testid="footer-whatsapp" href={whatsappHref()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-ax-sub hover:text-emerald-400 transition-colors mt-3">
          <MessageCircle className="w-4 h-4" /> WhatsApp Business
        </a>
      </div>
      <div>
        <h5 className="font-mono text-xs uppercase tracking-widest text-ax-muted mb-4">Setores</h5>
        <div className="flex flex-col gap-2.5">
          {SECTORS.map((s) => (
            <Link key={s.slug} data-testid={`footer-sector-${s.slug}`} to={`/setores/${s.slug}`} className="text-sm text-ax-sub hover:text-ax-cyan transition-colors">
              Impressão 3D · {s.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-ax-border py-5 text-center text-xs text-ax-muted">
      © {new Date().getFullYear()} AxioForm 3D · Impressão 3D em Portugal
    </div>
  </footer>
);
